import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2A2A2A] text-[#FAF8F5]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="font-['Bodoni_Moda'] text-2xl font-bold mb-4">COUNTRY BO</h3>
            <p className="text-[#B8B5B0] text-sm leading-relaxed max-w-md">
              Bold flavor. No fuss. Premium seasoning blends made for real kitchens and real cooks who want meals that taste like they know what they're doing.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider mb-4">Shop</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/shop" className="text-[#B8B5B0] hover:text-white text-sm transition-colors" data-testid="footer-shop">
                  All Blends
                </Link>
              </li>
              <li>
                <Link to="/shop/herb-savory" className="text-[#B8B5B0] hover:text-white text-sm transition-colors">
                  Herb & Savory
                </Link>
              </li>
              <li>
                <Link to="/shop/citrus-garlic" className="text-[#B8B5B0] hover:text-white text-sm transition-colors">
                  Citrus Garlic
                </Link>
              </li>
              <li>
                <Link to="/shop/smoky-savory" className="text-[#B8B5B0] hover:text-white text-sm transition-colors">
                  Smoky Savory
                </Link>
              </li>
              <li>
                <Link to="/shop/seafood-seasoning" className="text-[#B8B5B0] hover:text-white text-sm transition-colors">
                  Seafood Seasoning
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-semibold text-sm uppercase tracking-wider mb-4">Info</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-[#B8B5B0] hover:text-white text-sm transition-colors" data-testid="footer-about">
                  About
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-[#B8B5B0] hover:text-white text-sm transition-colors" data-testid="footer-faq">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#B8B5B0] hover:text-white text-sm transition-colors" data-testid="footer-contact">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/track" className="text-[#B8B5B0] hover:text-white text-sm transition-colors" data-testid="footer-track-order">
                  Track Order
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-[#B8B5B0] hover:text-white text-sm transition-colors" data-testid="footer-privacy">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-[#B8B5B0] hover:text-white text-sm transition-colors" data-testid="footer-terms">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/refunds" className="text-[#B8B5B0] hover:text-white text-sm transition-colors" data-testid="footer-refunds">
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="text-[#B8B5B0] hover:text-white text-sm transition-colors" data-testid="footer-shipping">
                  Shipping Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#444] mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between">
          <p className="text-[#B8B5B0] text-sm">
            © {currentYear} Country Bo Foods. All rights reserved.
          </p>
          <p className="text-[#B8B5B0] text-sm mt-2 sm:mt-0">
            Put Some Bo On It.™
          </p>
        </div>
      </div>
    </footer>
  );
};
